export const APP_COOKIE_NAME = {
    'APP_OS': 'APP_OS',
    'APP_OS_VERSION': 'APP_OS_VERSION',
    'APP_VERSION': 'APP_VERSION',
    'APP_CODE': 'APP_CODE',
}

export const MEMBER_COOKIE_NAME = {
    SERVICE_ID: 'serviceId',
    CHANNEL_ID: 'channelId',
}

export const APP_CODE = {
    SCHOOL: 'SCHOOL',
    PRIVATE_SCHOOL: 'PRIVATE_SCHOOL',
    STUDENT: 'STUDENT',
    SCHOOL_ID: 'SCHOOL_ID',
    PRIVATE_SCHOOL_ID: 'PRIVATE_SCHOOL_ID',
    TEACHER: 'TEACHER',
}

export const SERVICE_ID = {
    IAMSCHOOL: 'iamschool',
    IAMSTUDENT: 'iamstudent',
}

export const CHANNEL_ID = {
    APP: 'app',
    PRIVATE_APP: 'private_app',
}